import {useState, useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import {useFirestoreConnect, isLoaded} from "react-redux-firebase";
import firebase from '../../src/config/firebaseConfig'

export default function useUsers() {
    const [loading, setLoading] = useState(true);
    const getData = useSelector(state => state.firestore.ordered['users']);

    // console.log(getData)

    const users = useMemo(() => getData || [], [getData])

    useEffect(() => setLoading(!isLoaded(getData)), [getData])

    // console.log('hook users info' , users)


    useFirestoreConnect(() => [
        {
            collection: 'users',
            // where: [
            //     ['role', '!=', 'client']
            // ],
            storeAs: 'users'
        }
    ]);

    const userid = firebase.auth()?.currentUser?.uid 

    // console.log(userid)

    const userInfo = users.find(e => e?.id === userid)

    // console.log("user info is ....", userInfo)

    return {users, userInfo, loading}
}